import _extends from "@babel/runtime/helpers/esm/extends";
import { EModel } from './model';
import { fieldsUser } from './user';
export let EGuestSource;
(function (EGuestSource) {
  EGuestSource["Telehealth"] = "telehealth";
})(EGuestSource || (EGuestSource = {}));
export let ERelationshipType;
(function (ERelationshipType) {
  ERelationshipType["Parent"] = "parent";
  ERelationshipType["Guardian"] = "guardian";
  ERelationshipType["Child"] = "child";
  ERelationshipType["Spouse"] = "spouse";
  ERelationshipType["Guarantor"] = "guarantor";
  ERelationshipType["Friend"] = "friend";
  ERelationshipType["Caretaker"] = "caretaker";
  ERelationshipType["Interpreter"] = "interpreter";
  ERelationshipType["MedicalScribe"] = "medical-scribe";
  ERelationshipType["MedicalStudent"] = "medical-student";
  ERelationshipType["Other"] = "other";
})(ERelationshipType || (ERelationshipType = {}));
export const fieldsGuest = _extends({}, fieldsUser, {
  otherRelationshipType: {
    type: 'Text'
  },
  relationship: {
    type: 'ID',
    ref: EModel.User
  },
  relationshipType: {
    type: 'Option',
    values: ERelationshipType
  },
  source: {
    type: 'Option',
    values: EGuestSource
  },
  visible: {
    type: 'Boolean'
  }
});